import { render, staticRenderFns } from "./agendaClinica.vue?vue&type=template&id=3e1ed18b"
import script from "./agendaClinica.vue?vue&type=script&lang=js"
export * from "./agendaClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports